export enum TransitionProperty {
    all,
    width,
    height,
    'background-color',
    color,
    transform
}
